import React from 'react';
import { Radio } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

/**
 * Display Radio button to change mode of resale :
 *      enabled on all event by default
 *      disabled on all event by default
 * @param resaleMode : resale mode checked on organization
 * @param setResaleMode : func to change the mode
 *
 */
export default function ModeSelector({ resaleMode, onChangeMode }) {
    const { t } = useTranslation();
    return (
        <div>
            <div className={'sub_header_title'}>
                <Trans i18nKey="ticket.resales.config.mode_select_title">Resales Mode</Trans>
            </div>
            <Radio
                className={'resale_radio_button'}
                label={t('ticket.resales.config.mode_select_activated')}
                name="radioGroup"
                value="Activated"
                checked={resaleMode === true}
                onChange={() => onChangeMode(true)}
            />
            <p>
                <Radio
                    className={'resale_radio_button'}
                    label={t('ticket.resales.config.mode_select_disabled')}
                    name="radioGroup"
                    value="Disabled"
                    checked={resaleMode === false}
                    onChange={() => onChangeMode(false)}
                />
            </p>
        </div>
    );
}

ModeSelector.propTypes = {
    resaleMode: PropTypes.bool,
    onChangeMode: PropTypes.func.isRequired
};
